import $ from 'jquery';

const $window = $(window);
const $navbar = $('.js-navbar');

$window.on('scroll', () => {
  const positionWindow = $window.scrollTop();
  const positionOffset = 15;
  const positionNavbar = $navbar.offset().top - positionOffset;
  if (positionWindow && positionNavbar) {
    $navbar.toggleClass('is-fixed', positionWindow > positionNavbar);
  }
});
